import { LockKeyhole, Mail, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface AssetRequestAccessProps {
  assetId?: string;
  assetName?: string;
}

export const AssetRequestAccess = ({ assetId, assetName }: AssetRequestAccessProps) => {
  const navigate = useNavigate();

  const handleRequestAccess = () => {
    // TODO: Implement request access functionality
    // This could open a modal, send an email, or navigate to a request form
    alert('Request access functionality will be implemented');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-gray-100 dark:bg-gray-800 p-6">
            <LockKeyhole className="h-12 w-12 text-gray-400 dark:text-gray-500" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
            Access Required
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {assetName
              ? `You don't have permission to view "${assetName}".`
              : "You don't have permission to view this asset."}
          </p>
        </div>

        {/* Description */}
        <div className="text-sm text-gray-500 dark:text-gray-400 space-y-2">
          <p>
            This asset is private and can only be accessed by users with appropriate permissions.
          </p>
          <p>
            You can request access from the asset owner or contact your administrator.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </Button>
          <Button
            onClick={handleRequestAccess}
            className="gap-2"
          >
            <Mail className="h-4 w-4" />
            Request Access
          </Button>
        </div>

        {/* Additional Info */}
        {assetId && (
          <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
            <p className="text-xs text-gray-400 dark:text-gray-500">
              Asset ID: <code className="font-mono">{assetId}</code>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
